export default __webpack_public_path__ + "static/media/p64.0ef27cc4.jpg";